/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
	import RecommendationJpd from '@post-office/message-template--recommendation-jpd/placements/in-app/confluence-home-banner/render';
	import RecommendationJsm from '@post-office/message-template--recommendation-jsm/placements/in-app/confluence-home-banner/render';
	import RecommendationJswRealTimeUpdates from '@post-office/message-template--recommendation-jsw-real-time-updates/placements/in-app/confluence-home-banner/render';
	import RecommendationJswTechTeams from '@post-office/message-template--recommendation-jsw-tech-teams/placements/in-app/confluence-home-banner/render';
	import RecommendationJswVisualizeWork from '@post-office/message-template--recommendation-jsw-visualize-work/placements/in-app/confluence-home-banner/render';

export default {
	'recommendation-jpd': RecommendationJpd,
	'recommendation-jsm': RecommendationJsm,
	'recommendation-jsw-real-time-updates': RecommendationJswRealTimeUpdates,
	'recommendation-jsw-tech-teams': RecommendationJswTechTeams,
	'recommendation-jsw-visualize-work': RecommendationJswVisualizeWork,
};
